var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcKucoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#23AF91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7496 15.9898L19.0079 21.249L22.3269 17.9299C22.9204 17.3955 23.8284 17.4193 24.3931 17.984C24.9578 18.5487 24.9816 19.4567 24.4472 20.0502L20.0672 24.431C19.4789 25.0096 18.5353 25.0096 17.9469 24.431L11.6277 18.1101V21.8671C11.6277 22.6963 10.9555 23.3684 10.1263 23.3684C9.29717 23.3684 8.625 22.6963 8.625 21.8671V10.1077C8.625 9.27852 9.29717 8.60636 10.1263 8.60636C10.9555 8.60636 11.6277 9.27852 11.6277 10.1077V13.8647L17.9461 7.5454C18.5343 6.96635 19.4782 6.96635 20.0664 7.5454L24.4497 11.9254C24.9841 12.5189 24.9603 13.4269 24.3956 13.9916C23.8309 14.5563 22.9229 14.5801 22.3294 14.0457L19.0103 10.7266L13.7496 15.9898ZM19.0103 14.4869C18.4024 14.4866 17.8541 14.8525 17.6212 15.4141C17.3883 15.9757 17.5167 16.6223 17.9465 17.0523C18.3762 17.4823 19.0228 17.6111 19.5845 17.3785C20.1462 17.1459 20.5125 16.5978 20.5125 15.9898C20.5127 15.5912 20.3545 15.2089 20.0728 14.9269C19.7911 14.6448 19.4089 14.4863 19.0103 14.4861V14.4869Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKucoin);
export default __webpack_public_path__ + "static/media/ic_kucoin.18b724abc75c700858e174b153441313.svg";
export { ForwardRef as ReactComponent };